"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NumberOfCoachingDays_1 = __importDefault(require("./NumberOfCoachingDays"));
const CoachingDaysAdapter_1 = __importDefault(require("./CoachingDaysAdapter"));
exports.default = (rawPeriod, merge = false) => {
    const base = {};
    if (merge) {
        Object.assign(base, rawPeriod);
    }
    return {
        ...base,
        periodId: rawPeriod.periodId ? rawPeriod.periodId.toString() : null,
        subscriptionId: rawPeriod.subscriptionId
            ? rawPeriod.subscriptionId.toString()
            : null,
        day: rawPeriod.day ? rawPeriod.day : null,
        week: rawPeriod.week ? rawPeriod.week : null,
        startDate: rawPeriod.start ? rawPeriod.start : null,
        endDate: rawPeriod.end ? rawPeriod.end : null,
        periodType: rawPeriod.model
            ? {
                typeId: rawPeriod.model,
                numberOfCoachingDays: (0, NumberOfCoachingDays_1.default)(rawPeriod.model),
            }
            : null,
        coachingDays: (rawPeriod === null || rawPeriod === void 0 ? void 0 : rawPeriod.model) && (rawPeriod === null || rawPeriod === void 0 ? void 0 : rawPeriod.coachingDays)
            ? (0, CoachingDaysAdapter_1.default)(rawPeriod.model, rawPeriod.coachingDays)
            : null,
    };
};
//# sourceMappingURL=RawPeriodToPeriodAdapter.js.map